import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../controller/ClientApiController/CreateClientApiController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import CompanyListService from "../../../SuperAdmin/Controller/Client/SACompanyListController";
function CreateContractRates({ ClientApi, onClose, onSuccess }) {
    const { t } = useTranslation();
    const [companyList, setCompanies] = useState([]);
    const getCurrentDate = () => {
        return new Date().toISOString().split('T')[0];
    };
    const currentDate = getCurrentDate();

    const [formData, setFormData] = useState({
        ID: 0, APIName: "", BaseURL: "", Username: "", Password: "",
        CompanyCode: "", SupplierCode: "", FromDate: currentDate, Todate: currentDate, IntervalMinutes: "10", ClientID: 0
    });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        fetchClients();
        if (ClientApi) {
            setFormData({
                ID: ClientApi.ID, APIName: ClientApi.APIName, BaseURL: ClientApi.BaseURL,
                Username: ClientApi.Username, Password: ClientApi.Password, CompanyCode: ClientApi.CompanyCode,
                SupplierCode: ClientApi.SupplierCode, FromDate: ClientApi.FromDate,
                Todate: ClientApi.Todate, IntervalMinutes: ClientApi.IntervalMinutes, ClientID: ClientApi.ClientID
            });
        } else {
            setFormData({
                ID: 0, APIName: "", BaseURL: "", Username: "", Password: "",
                CompanyCode: "", SupplierCode: "", FromDate: currentDate, Todate: currentDate, IntervalMinutes: "10", ClientID: 0
            }); // Clear form data when switching to add mode
        }
    }, [ClientApi]);

    const fetchClients = async () => {
        try {
            const CompanyList = await CompanyListService.GetAllCompanies(() => navigate('/'));
            setCompanies(CompanyList);
        } catch (error) {
            console.error('Error fetching clients:', error);
        }
    };


    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault(); // Prevent default form submission
        if (ClientApi) {
            formData.ID = ClientApi.ID;
        } else {
            formData.ID = 0;
        }
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };

        const response = await handleSubmit(event, formData, setFormData, setErrors)
        if (response.message == "Data saved successfully") {
            onSuccess();
            onClose();
        }
    };
    return (
        <div>
            <form onSubmit={handleFormSubmit}>

                <div className="modal fade clientAPoModal show d-block" id="clientAPoModal" data-backdrop="static" data-keyboard="false" role="dialog" aria-labelledby="myExtraLargeModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">{ClientApi ? "Edit" : "Add"}</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">

                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Company:<span style={{ "color": "red" }}>*</span></label>
                                    <div className="col-sm-4">
                                        <select name="ClientID" className='form-control' value={formData.ClientID} onChange={handleFieldChange}>
                                            <option value="0">Select Company</option>
                                            {companyList.map((company) => (
                                                <option key={company.CoSetupID} value={company.CoSetupID}>
                                                    {company.CompanyName}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.PriorityName && <div style={{ color: 'red' }}>{errors.PriorityName}</div>}
                                    </div>
                                    <label htmlFor="APIName" className="col-sm-2 col-form-label">Api Name</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="APIName" value={formData.APIName}
                                            onChange={handleFieldChange}
                                        />
                                    </div>

                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                    <label htmlFor="Path" className="col-sm-2 col-form-label">URL</label>
                                    <div className="col-sm-10">
                                        <input type="text" className="form-control" name="BaseURL" value={formData.BaseURL}
                                            onChange={handleFieldChange}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                    <label htmlFor="Path" className="col-sm-2 col-form-label">User Name</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="Username" value={formData.Username}
                                            onChange={handleFieldChange}
                                        />
                                    </div>
                                    <label htmlFor="Password" className="col-sm-2 col-form-label">Password</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="Password" value={formData.Password}
                                            onChange={handleFieldChange}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                    <label htmlFor="Path" className="col-sm-2 col-form-label">Company Code</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="CompanyCode" value={formData.CompanyCode}
                                            onChange={handleFieldChange}
                                        />
                                    </div>
                                    <label htmlFor="SupplierCode" className="col-sm-2 col-form-label">Supplier Code</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="SupplierCode" value={formData.SupplierCode}
                                            onChange={handleFieldChange}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                    <label htmlFor="Path" className="col-sm-2 col-form-label">From Date</label>
                                    <div className="col-sm-4">
                                        <input type="date" className="form-control" name="FromDate" value={formData.FromDate}
                                            onChange={handleFieldChange}
                                        />
                                    </div>
                                    <label htmlFor="Todate" className="col-sm-2 col-form-label">To Date</label>
                                    <div className="col-sm-4">
                                        <input type="date" className="form-control" name="Todate" value={formData.Todate}
                                            onChange={handleFieldChange}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                    <label htmlFor="Path" className="col-sm-2 col-form-label">Interval</label>
                                    <div className="col-sm-4">
                                        <input type="number" className="form-control" name="IntervalMinutes" value={formData.IntervalMinutes}
                                            onChange={handleFieldChange}
                                        />
                                    </div>

                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                    <i className="icofont-save" aria-hidden="true"> {ClientApi ? " Update" : " Save"}</i>
                                </button>
                                <button className="btn btn-secondary" type="button" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                    <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

        </div>
    );
}

export default CreateContractRates;